import React from "react";
import { Link } from "react-router-dom";

export const Wordmark = ({ compact = false, tone = "olive" }) => {
  const color = tone === "cream" ? "var(--cream)" : "var(--olive)";
  return (
    <Link to="/" data-testid="wordmark-home-link" className="inline-block" style={{ color }}>
      <div className="font-serif-editorial wide-track leading-none" style={{ fontSize: compact ? "1.35rem" : "1.6rem", letterSpacing: "0.28em" }}>
        SIBO
      </div>
      <div className="font-serif-editorial wide-track leading-none mt-1" style={{ fontSize: compact ? "0.62rem" : "0.72rem", letterSpacing: "0.42em", opacity: 0.85 }}>
        INSTITUTE
      </div>
    </Link>
  );
};

export default Wordmark;
